'use client';

import { useGateValue } from '@statsig/react-bindings';

import ContentControl from './content-control';
import ContentRedesign from './content-redesign';

interface ContentProps {
  readonly localePartialUrl: string;
}

const Content = ({ localePartialUrl }: ContentProps) => {
  const membershipPageRedesign = useGateValue('membership_page_redesign');

  return membershipPageRedesign ? (
    <ContentRedesign />
  ) : (
    <ContentControl localePartialUrl={localePartialUrl} />
  );
};

export default Content;
